import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PersonalDataService } from '../../service/personal-data.service';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../../app/shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { TrackTypes } from '../../../shared/service/journey/tracks/model/track-types';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsAdjustPageService } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-page.service';
import { AnalyticsAdjustPagesModel } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-pages-models';


@Component({
  selector: "app-document-number",
  templateUrl: "./document-number.component.html",
  styleUrls: ["./document-number.component.scss"],
})
export class DocumentNumberComponent
  extends DefaultPageComponent
  implements OnInit
{
  public idComponentNumber = "documentNumber";
  public documentNumber = "";
  placeholder = "";
  title = "";
  labelAria = "";
  document = "";
  labelRg = "Qual o número do seu R G?";
  labelRne = "Qual o número do seu R N E?";
  labelCnh = "Qual o número da sua C N H?";
  titleRg = "Qual o número do seu RG?";
  titleCnh = "Qual o número da sua CNH?";
  titleRne = "Qual o número do seu RNE?";
  invalidErrorText = "Documento inválido";
  invalidErrorTextRg = "RG inválido";
  invalidErrorTextRne = "RNE inválido";
  invalidErrorTextCnh = "CNH inválida";
  textError = "";
  maxLength = "";
  documentType = "";
  number = "";
  error = false;
  buttonEnable = false;
  type = "";
  idLabel = "numberDocument";
  label = "numero do documento";
  headerId = "document-number";
  titleWebPage = "Dados pessoais";
  replaceStrTo = "document";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  analyticsPageAdjust: AnalyticsAdjustPagesModel;
  idLabelNumber = "numberDocumentLabel";
  idButtonNumber = "buttonNumber";

  numberForm = this.formBuilder.group({
    docNumber: this.formBuilder.control("", [Validators.required]),
  });

  constructor(public router: NavController,
              private personalDataService: PersonalDataService,
              public backNativeService: BackNativeService,
              private formBuilder: FormBuilder,
              private titlePage: Title,
              public journeyService: JourneyService,
              public returnNativeService: ReturnNativeService,
              public analycticsNativeService: AnalycticsNativeService,
              private analyticsPageService: AnalyticsPageService,
              private analyticsGA4PageService: AnalyticsGA4PageService,
              private analyticsAdjustPageService: AnalyticsAdjustPageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getAnalyticsPageAdjust();
    this.getTrack();
  }

  /* istanbul ignore next */
  get docNumber() {
    return this.numberForm.get("docNumber");
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDocumentType();
    this.editFieldInvest("documento_numero", "documentNumber", "personalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getAnalyticsPageAdjust() {
    this.analyticsPageAdjust = this.analyticsAdjustPageService.setAnalyticsPageAdjust();
  }


  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "3";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = `${this.analyticsPage.documentNumber}${this.document}`;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathNumeroDocumento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    const paramComplementary = {
      detail: this.document.toLowerCase(),
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  sendTrackAdjustLoadPage() {
    const paramDefautl = {
      it_token: this.analyticsPageAdjust.criarconta_dados_documento_numero,
    }

    this.analyticsAdjustPageService.sendTrackAdjust(paramDefautl)
  }

  setTitle() {
    this.titlePage.setTitle(this.titleWebPage);
  }

  getDocumentType() {
    this.documentType = this.personalDataService.getDocumentTypeData();

    switch (this.documentType) {
      case "551":
        this.title = this.titleRg;
        this.labelAria = this.labelRg;
        this.document = "RG";
        this.placeholder = "0000000000000";
        this.maxLength = "13";
        this.numberForm = this.formBuilder.group({
          docNumber: this.formBuilder.control("", [
            FormValidations.validationsNumberRg,
            Validators.maxLength(parseInt(this.maxLength, 10)),
          ]),
        });
        this.type = "text";
        break;
      case "558":
        this.title = this.titleCnh;
        this.labelAria = this.labelCnh;
        this.document = "CNH";
        this.placeholder = "00000000000";
        this.maxLength = "11";
        this.numberForm = this.formBuilder.group({
          docNumber: this.formBuilder.control("", [
            FormValidations.validationsNumberCnh,
            Validators.maxLength(parseInt(this.maxLength, 10)),
          ]),
        });
        this.type = "tel";
        this.replaceStrTo = "number";
        break;
      case "552":
        this.title = this.titleRne;
        this.labelAria = this.labelRne;
        this.document = "RNE";
        this.numberForm = this.formBuilder.group({
          docNumber: this.formBuilder.control("", [
            FormValidations.validationsNumberRne,
            Validators.maxLength(parseInt(this.maxLength, 10)),
          ]),
        });
        this.placeholder = "000000000";
        this.maxLength = "9";
        this.type = "text";
        break;
      default:
        this.title = this.titleRg;
        this.labelAria = this.labelRg;
        this.document = "RG";
        this.placeholder = "0000000000000";
        this.maxLength = "13";
        this.numberForm = this.formBuilder.group({
          docNumber: this.formBuilder.control("", [
            FormValidations.validationsNumberRg,
          ]),
        });
        this.type = "text";
        break;
    }
  }

  errorMsg() {
    const control = this.numberForm.get("docNumber") as FormControl;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("minlengthRg")
    ) {
      this.textError = this.invalidErrorTextRg;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("numberRepeatedRg")
    ) {
      this.textError = this.invalidErrorTextRg;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("numberCharacterRg")
    ) {
      this.textError = this.invalidErrorTextRg;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("characterRepeatedRg")
    ) {
      this.textError = this.invalidErrorTextRg;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("minlengthRne")
    ) {
      this.textError = this.invalidErrorTextRne;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("numberCharacterRne")
    ) {
      this.textError = this.invalidErrorTextRne;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("numberRepeatedRne")
    ) {
      this.textError = this.invalidErrorTextRne;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("characterRepeatedRne")
    ) {
      this.textError = this.invalidErrorTextRne;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("minlengthCnh")
    ) {
      this.textError = this.invalidErrorTextCnh;
    }
    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("numberRepeatedCnh")
    ) {
      this.textError = this.invalidErrorTextCnh;
    }
    if (control.errors !== null && control.errors.hasOwnProperty("maxlength")) {
      switch (this.document) {
        case "RG":
          this.textError = this.invalidErrorTextRg;
          break;
        case "RNE":
          this.textError = this.invalidErrorTextRne;
          break;
        case "CNH":
          this.textError = this.invalidErrorTextCnh;
          break;
        default:
          break;
      }
    }
  }

  clickNext() {
    this.personalDataService.setDocumentNumber(this.number);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: `${this.analyticsPage.documentNumber}${this.document}`,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    this.getDocumentType();
    if (
      this.journeyService.registratioJourney.data.personalData.documentNumber
    ) {
      if (this.replaceStrTo === "number") {
        this.number =
          this.journeyService.registratioJourney.data.personalData.documentNumber.replace(
            /[^0-9]+/gm,
            ""
          );
      } else {
        this.number =
          this.journeyService.registratioJourney.data.personalData.documentNumber;
      }
      this.numberForm.controls.docNumber.setValue(this.number);
      this.numberForm.controls.docNumber.updateValueAndValidity({
        onlySelf: true,
        emitEvent: true,
      });
      this.errorMsg();
    }
    this.analyticsData();
    this.sendTrackGA4LoadPage();
    this.sendTrackAdjustLoadPage();
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
